import { combineReducers } from 'redux';
import {
  setStep,
  setSteps
} from './reducer-steps';
import toggleAudio from './reducer-audio';
import toggleSnowflakes from './reducer-snowflakes';
import toggleTimeline from './reducer-timeline';
import shuffleQuotes from './reducer-quotes';
import { setTheme, shuffleThemes } from './reducer-themes';

const allReducers = combineReducers({
  currentStep: setStep,
  steps: setSteps,
  audio: toggleAudio,
  snowflakes: toggleSnowflakes,
  quotes: shuffleQuotes,
  timeline: toggleTimeline,
  currentTheme: setTheme,
  themes: shuffleThemes
});

export default allReducers;



/** WEBPACK FOOTER **
 ** ./src/js/reducers/index.js
 **/